// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"26759783","453":"01e2d527","732":"e1ccb94c","977":"fc3773d9"}[chunkId] + ".chunk.js";
};